import React from 'react';
import { WashingMachine } from 'lucide-react';
export function Footer() {
  return <div className="bg-[#0f2424] border-t border-gray-800 py-6 sm:py-8" data-id="element-76">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-77">
        <div className="flex items-center space-x-2" data-id="element-78">
          <WashingMachine className="h-5 w-5 sm:h-6 sm:w-6 text-[#4fd1c5]" data-id="element-79" />
          <span className="text-base sm:text-lg font-bold text-white tracking-tight" data-id="element-80">
            LAUNDRY <span className="font-light" data-id="element-81">INVESTORS</span>
          </span>
        </div>
        <p className="text-gray-500 text-xs sm:text-sm text-center" data-id="element-82">
          &copy; {new Date().getFullYear()} Laundry Investors. All rights
          reserved.
        </p>
      </div>
    </div>;
}